import { ContainerModule } from 'inversify'
import { StreamStore } from 'store/stream'
import TYPES from '../../config/inversify.types'
import { StreamServiceImpl } from './stream.service.impl'

export const StreamModule = new ContainerModule((bind) => {
    bind(TYPES.StreamService).to(StreamServiceImpl).inSingletonScope()
    bind(TYPES.StreamStore).to(StreamStore).inSingletonScope()
})
